import { render } from "./HeroiconsSolidCloud.vue?vue&type=template&id=6d2a5f1e"
const script = {}

import exportComponent from "/var/www/html/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidCloud.vue"]])

export default __exports__